import { render } from "./EditPersonalData.vue?vue&type=template&id=19b54f22&scoped=true"
import script from "./EditPersonalData.vue?vue&type=script&lang=js"
export * from "./EditPersonalData.vue?vue&type=script&lang=js"

import "./EditPersonalData.vue?vue&type=style&index=0&id=19b54f22&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b54f22"]])

export default __exports__